
export class SharedStrings {
    static readonly SUPPORT_EMAIL = 'help@colonist.io'
    static readonly DISCORD_CHANNEL = 'https://discord.gg/colonist'
    static readonly DISCORD_SERVER_ID = '605233308577562643'
    static readonly BLOG_URL = 'https://blog.colonist.io'
    static readonly FEATURE_UPVOTE_URL = 'https://colonist.featureupvote.com'
    static readonly APP_STORE_URL = 'https://apps.apple.com/us/app/colonist-io/id6444831129'
    static readonly PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.colonist.colonist'
}
